import ApplicationLayout from 'components/ApplicationLayout';
import CustomProvider from 'components/CustomProvider';
import SignUpForm from 'components/SignUpForm';
import LoginSignupLayout from 'components/LoginSignupLayout';

type Props = {
  redirectTo: string;
  mapTagging?: {
    invitedByUserFirstName: string;
  };
};

export default function SignUp({ redirectTo, mapTagging }: Props) {
  return (
    <CustomProvider>
      <ApplicationLayout>
        <LoginSignupLayout showBranchInterstitial={!redirectTo.includes('/plus/checkout')} redirectTo={redirectTo}>
          <SignUpForm redirectTo={redirectTo} mapTagging={mapTagging} />
        </LoginSignupLayout>
      </ApplicationLayout>
    </CustomProvider>
  );
}
